import Editor, { EditorProps } from "@monaco-editor/react";
import { LoadingC } from "..";
import "./index.less";

interface CodeEditorCProps extends EditorProps {}
const CodeEditorC = (props: CodeEditorCProps) => {
  return (
    <div style={{ direction: "ltr" }} className="monaco-editor-class">
      <Editor loading={<LoadingC />} {...props} />
    </div>
  );
};

export default CodeEditorC;
